/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Mod_HeadingInputs */

const es_footer_mod_heading = /** @type {(inputs: Footer_Mod_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalidades`)
};

const gl_footer_mod_heading = /** @type {(inputs: Footer_Mod_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalidades`)
};

const en_footer_mod_heading = /** @type {(inputs: Footer_Mod_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options`)
};

/**
* | output |
* | --- |
* | "Options" |
*
* @param {Footer_Mod_HeadingInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_mod_heading = /** @type {((inputs?: Footer_Mod_HeadingInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Mod_HeadingInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_mod_heading(inputs)
	if (locale === "en") return en_footer_mod_heading(inputs)
	return es_footer_mod_heading(inputs)
});